<main id="content-page">
    <div class="main-panel">
        <div class="row article-row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="article-wrap">
                    <div class="article-inner-container">
                        <div class="row">
                            <div class="col-lg-9 col-md-9 col-sm-12 article-column">
                                <article class="article-content">
                                    <div class="text-center">
                                        <h1>LawShelf Sitemap<i [ngStyle]="{display: getRetrievedStyle()}"
                                                style="color: #337ab7; font-weight: 800; font-size: 22px; margin-left: 20px"
                                                class="fa fa-spinner fa-spin"></i></h1>
                                    </div>
                                </article>
                                <h1>Video-Courses</h1>
                                <ul *ngIf="siteMap">
                                    <li *ngFor="let aRootTopic of siteMap.DigitalBadgeTopics" class="margin-bottom-20">
                                        <strong>
                                            <a
                                                [routerLink]="['/videocoursesview', aRootTopic.Alias]">{{ aRootTopic.Title}}</a>
                                        </strong>
                                        <ul>
                                            <app-site-map-entry *ngFor="let aSubTopic of aRootTopic.videoCourses"
                                                [entry]="aSubTopic"></app-site-map-entry>
                                        </ul>
                                    </li>
                                </ul>
                                <h1>Foundations of Law</h1>
                                <ul *ngIf="siteMap && siteMap.CoursewareTopics">
                                    <li *ngFor="let aRootTopic of siteMap.CoursewareTopics" class="margin-bottom-20">
                                        <strong>
                                            <a
                                                [routerLink]="['/coursewareview', aRootTopic.Alias]">{{ aRootTopic.Title}}</a>
                                        </strong>
                                        <ul *ngFor="let aSubTopic of aRootTopic.Children">
                                            <li>
                                                <a
                                                    [routerLink]="['/coursewareview', aRootTopic.Alias, aSubTopic.Alias]">{{ aSubTopic.Title}}</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <h1>Short Videos</h1>
                                <ul *ngIf="siteMap && siteMap.ArticleTopics">
                                    <li *ngFor="let aRootTopic of siteMap.ArticleTopics" class="margin-bottom-20">
                                        <strong>
                                            <a
                                                [routerLink]="['/shortvideosview', aRootTopic.Alias]">{{ aRootTopic.Title}}</a>
                                        </strong>
                                    </li>
                                </ul>
                                <h1>Blog</h1>
                                <ul *ngIf="siteMap && siteMap.LastBlogEntries">
                                    <li *ngFor="let aContentEntry of siteMap.LastBlogEntries" class="margin-bottom-20">
                                        <strong>
                                            <a
                                                [routerLink]="['/blogentryview', aContentEntry.Information.Alias]">{{ aContentEntry.Information.Title}}</a>
                                        </strong>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>